module.exports = __webpack_public_path__ + "assets/img/40a773b279f117378fad1780a66f9e8d.png";